import VVSTable from "components/form-control/VVSTable";
import React from "react";
import { Container } from "reactstrap";

export default function RefferalBonus() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <VVSTable name="RefferalBonus" title="Hoa hồng" disableAdd />
        </Container>
      </div>
    </React.Fragment>
  );
}
